import { Language } from '@vlaio/shared/types';

export const LoadingText: Record<Language, string> = {
	en: 'Loading the website...',
	nl: 'De website wordt geladen...',
	fr: 'Chargement du site...'
};
